import PostApiBase from "@/modules/post/services/ApiBase"
import {axios as http} from "@/plugins/http";

export default class Api {
    static item(postId) {
        return PostApiBase.telegramPost({
            post_id: postId
        }).then((resp) => {
            return resp.data["item"]
        })
    }

    static saveDraft(q) {
        return PostApiBase.telegramSaveDraft(q).then((resp) => {
            return resp.data["item"]
        })
    }

    static createDraft(q) {
        return PostApiBase.telegramCreateDraft(q).then((resp) => {
            return resp.data["id"]
        })
    }

    static published(q) {
        return PostApiBase.telegramPublished(q)
    }

    static scheduled(q) {
        return PostApiBase.telegramScheduled(q)
    }

    static save(q) {
        return PostApiBase.telegramSave(q)
    }

    static saveDelete(q) {
        return PostApiBase.saveDelete(q)
    }

    static chainBindInPost(thisObjectId, thatObjectId, thisTypeId, thatTypeId) {
        return PostApiBase.chainBindInPost({
            this_object_id: thisObjectId,
            that_object_id: thatObjectId,
            this_type_id: thisTypeId,
            that_type_id: thatTypeId,
        }).then((resp) => {
            return resp.data
        })
    }

    static async publish(data) {
        return http.post("/api/v1/promocodes/coupon/publish", data)
    }
}
